<template>
  <div class="card-n">
    <div class="title">
      {{ $t("home.components.transOut.input-pwd") }} 
    </div>
    <div class="form-group">
      <span class="form-label">
        {{ $t("home.components.transOut.verify") }}:
      </span>
      <input
        class="input-text"
        v-model="pwd"
        type="password"
        :placeholder="$t('home.components.transOut.HDpwd')"
      />
    </div>
    <div style="text-align: right;">
      <button class="btn btn-blue-sm" @click="submit">
        {{ $t("home.confrim") }}
      </button>
    </div>
  </div>
</template>
<script>
import { throttle} from 'lodash'
export default {
  data() {
    return {
      pwd: "",
    };
  },
  methods: {
    submit:throttle(function () {
      if (this.pwd) {
          this.$emit("submit", this.pwd);
       
      }
    } ,3000),
  }
};
</script>
<style lang="scss" scoped>
.card-n {
  padding: 2rem 2rem 3.5rem 2rem;
  width: 47.1rem;
  background: url("~@/assets/image/modal_xs.png") no-repeat;
  background-size: 100% 100%;
  .title {
    width: 100%;
    border-bottom: 0.1rem solid rgba(222, 222, 222, 0.4);
    padding-bottom: 2rem;
    color: #333333;
    font-size: 1.6rem;
    font-weight: bold;
    margin-bottom: 2.9rem;
    position: relative;
  }
  .form-group {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    .form-label {
      text-align: right;
      margin-right: 20px;
      font-weight: bold;
      color: #060606;
      line-height: 14px;
      font-size: 14px;
    }

    .input-text {
      flex: 1;
      background: #ffffff;
      border-radius: 2px;
      border: 1px solid #d9d8d8;
      padding: 8px 10px;
      font-size: 12px;
      font-weight: 400;
      color: #060606;
      line-height: 17px;
    }
    .all-trans {
      font-size: 12px;
      font-weight: 400;
      color: #e73419;
      line-height: 17px;
      margin-left: 10px;
    }
    .input-group {
      flex: 1;
      display: flex;
      input {
        border-radius: 2px 0px 0px 2px;
        border-right: none;
      }

      .suffix {
        background: rgba(217, 216, 216, 0.5);
        border-radius: 0px 2px 2px 0px;
        opacity: 0.5;
        line-height: 35px;
        border: 1px solid #d9d8d8;
        border-left: none;
        font-size: 12px;
        font-weight: 400;
        color: #060606;
        padding: 0 15px;
      }
    }
  }
}
</style>
